export const getLocalStorageFormRecord = (templateId: number): Record<string, any> | undefined => {
    const record = localStorage.getItem(`formRecord_${templateId}`);
    return record ? JSON.parse(record) : undefined;
}

export const setLocalStorageFormRecord = (templateId: number, record: Record<string, any>) => {
    localStorage.setItem(`formRecord_${templateId}`, JSON.stringify(record));
}
